import { Cake, Cake2Fill } from "react-bootstrap-icons";
import {
    FiMonitor,
    FiVolume2,
    FiStar,
    FiMusic,
    FiCamera,
    FiUsers,
    FiHome,
    FiGift,
    FiHeart,
    FiCalendar,
    FiClock,
    FiCheckCircle,
    FiSmile,
    FiCameraOff,
} from "react-icons/fi";

import {
    MdOutlineCelebration,
    MdOutlineCake,
    MdOutlineMovie,
    MdOutlineEventSeat,
    MdOutlineSecurity,
    MdOutlineSupportAgent,
} from "react-icons/md";


// tag name -> icon component
export const TAG_ICON_MAP = {
    // 🎬 Audio-Visual Experience
    "Ultra HD Projection": "bi bi-tv",
    "Cinematic Screen Size": "bi bi-film",
    "Immersive Sound Experience": "bi bi-volume-up",
    "Theatre-Grade Acoustics": "bi bi-speaker",

    // 🛋️ Comfort & Luxury
    "Luxury Recliner Seating": "bi bi-person-workspace",
    "Private & Intimate Setup": "bi bi-house-door",
    "Sofa-Style Seating": "bi bi-person-badge",
    "Premium Interior Ambience": "bi bi-stars",

    // 🔒 Privacy
    "100% Private Screening": "bi bi-shield-lock",
    "No Outside Disturbance": "bi bi-shield-check",
    "Couples-Only Privacy": "bi bi-heart",
    "Family-Friendly Privacy": "bi bi-people",

    // 🎉 Celebrations
    "Birthday Celebrations": "bi bi-cake",
    "Anniversary Specials": "bi bi-gift",
    "Proposal Setup": "bi bi-heart-fill",
    "Surprise Arrangements": "bi bi-balloon",
    "Balloon & Theme Décor": "bi bi-balloon-fill",
    "Celebration-Ready Space": "bi bi-stars",

    // 🍰 Food
    "Cakes": "bi bi-cake2",
    "Addons": "bi bi-plus-circle",
    "Snacks & Beverages": "bi bi-cup-straw",

    // 🕯️ Ambience
    "Romantic Lighting": "bi bi-lightbulb",
    "Mood-Based Lighting": "bi bi-lightbulb-fill",
    "Aesthetic Interiors": "bi bi-brush",
    "Instagram-Worthy Setup": "bi bi-camera",
    "Soft Ambient Lighting": "bi bi-lamp",
    "Elegant Décor Themes": "bi bi-palette",

    // ⚙️ Booking
    "Flexible Booking Slots": "bi bi-calendar",
    "Easy Rescheduling": "bi bi-clock",
    "No Hidden Charges": "bi bi-check-circle",
    "Transparent Pricing": "bi bi-receipt",
    "Hassle-Free Booking": "bi bi-check2-circle",

    // 🛎️ Support
    "Personalized Experience": "bi bi-emoji-smile",
    "Quick Setup Assistance": "bi bi-headset",
    "Friendly Staff Support": "bi bi-person-check",

    // 💎 Premium
    "Luxury Private Theatre": "bi bi-gem",
    "VIP Experience": "bi bi-star-fill",
    "Boutique Cinema": "bi bi-film",
    "Premium Celebration Space": "bi bi-trophy",
    "Perfect for Couples": "bi bi-heart",
    "Ideal for Small Groups": "bi bi-people",
    "Ideal for Large Groups": "bi bi-people-fill",

    // 👥 Guests
    "Maximum 2 Guests": "bi bi-people",
    "Maximum 4 Guests": "bi bi-people-fill",

    // // 🎬 Audio-Visual Experience
    // "Ultra HD Projection": FiMonitor,
    // "Cinematic Screen Size": MdOutlineMovie,
    // "Immersive Sound Experience": FiVolume2,
    // "Theatre-Grade Acoustics": FiVolume2,

    // // 🛋️ Comfort & Luxury
    // "Luxury Recliner Seating": MdOutlineEventSeat,
    // "Private & Intimate Setup": FiHome,
    // "Sofa-Style Seating": MdOutlineEventSeat,
    // "Premium Interior Ambience": FiStar,

    // // 🔒 Privacy & Exclusivity
    // "100% Private Screening": MdOutlineSecurity,
    // "No Outside Disturbance": MdOutlineSecurity,
    // "Couples-Only Privacy": FiHeart,
    // "Family-Friendly Privacy": FiUsers,

    // // 🎉 Celebrations & Events
    // "Birthday Celebrations": MdOutlineCake,
    // "Anniversary Specials": FiGift,
    // "Proposal Setup": FiHeart,
    // "Surprise Arrangements": MdOutlineCelebration,
    // "Balloon & Theme Décor": MdOutlineCelebration,
    // "Celebration-Ready Space": MdOutlineCelebration,

    // // 🍰 Food & Add-Ons
    // "Cakes": MdOutlineCake,
    // "Addons": FiGift,
    // "Snacks & Beverages": FiSmile,

    // // 🕯️ Ambience & Mood
    // "Romantic Lighting": FiHeart,
    // "Mood-Based Lighting": FiStar,
    // "Aesthetic Interiors": FiStar,
    // "Instagram-Worthy Setup": FiCamera,
    // "Soft Ambient Lighting": FiStar,
    // "Elegant Décor Themes": FiStar,

    // // ⚙️ Flexibility & Convenience
    // "Flexible Booking Slots": FiCalendar,
    // "Easy Rescheduling": FiClock,
    // "No Hidden Charges": FiCheckCircle,
    // "Transparent Pricing": FiCheckCircle,
    // "Hassle-Free Booking": FiCheckCircle,

    // // 🛎️ Service & Support
    // "Personalized Experience": FiSmile,
    // "Quick Setup Assistance": MdOutlineSupportAgent,
    // "Friendly Staff Support": MdOutlineSupportAgent,

    // // 💎 Premium Experience Tags
    // "Luxury Private Theatre": FiStar,
    // "VIP Experience": FiStar,
    // "Boutique Cinema": MdOutlineMovie,
    // "Premium Celebration Space": MdOutlineCelebration,
    // "Perfect for Couples": FiHeart,
    // "Ideal for Small Groups": FiUsers,
    // "Ideal for Large Groups": FiUsers,

    // // 👥 Guest Tags
    // "Maximum 2 Guests": FiUsers,
    // "Maximum 4 Guests": FiUsers,
};


export const renderTagWithIcon = (tag) => {
    const iconClass = TAG_ICON_MAP[tag];
    return (
        <span
            key={tag}
            className="theater-tag-chip"
        >

            {iconClass && (
                <i
                    className={iconClass}
                    aria-hidden="true"
                    className={`theater-tag-chip__icon ${iconClass}`}
                />
            )}

            <span className="theater-tag-chip__label">{tag}</span>
        </span>
    );
};



// import {
//     FiCloud,
//     FiWind,
//     FiStar,
//     FiMusic,
//     FiCamera,
//     FiVideo,
//     FiHeart,
//     FiUsers,
//     FiHome,
//     FiGift,
// } from "react-icons/fi";

// import {
//     MdOutlineLocalFireDepartment,
//     MdOutlineCelebration,
//     MdOutlineCake,
//     MdOutlinePhotoCameraFront,
// } from "react-icons/md";

// import {
//     AiOutlineAudio,
//     AiOutlineVideoCamera,
// } from "react-icons/ai";


// // tag name -> icon component
// export const TAG_ICON_MAP = {
//     "fog entry": FiCloud,
//     "cold pyro": FiWind,
//     "candle setup": MdOutlineLocalFireDepartment,
//     "red carpet entry": FiStar,
//     "romantic theme": FiHeart,
//     "couple entry": FiUsers,
//     "background music": FiMusic,
//     "live music": AiOutlineAudio,
//     "dj setup": MdOutlineCelebration,
//     "photography": FiCamera,
//     "videography": AiOutlineVideoCamera,
//     "photo booth": MdOutlinePhotoCameraFront,
//     "birthday theme": MdOutlineCake,
//     "anniversary theme": FiGift,
//     "proposal setup": FiHeart,
//     "private hall": FiHome,
// };
